import * as React from 'react'

import '../styles/ButtonGroup.scss'

export interface ButtonInfo {
    title: string
    id: any
    onClick?(): void
}

export interface ButtonGroupProps {
    buttons: ButtonInfo[]
    multiple?: boolean
    buttonsPerLine?: number
    onChanged?: (selectedValue: string | string[]) => void
}

interface ButtonGroupState {
    states: Map<string, boolean>
    buttons: ButtonInfo[][]
}

export class ButtonGroup extends React.Component<ButtonGroupProps, ButtonGroupState> {

    constructor(props: any) {
        super(props)
        this.state = {
            states: new Map<string, boolean>(),
            buttons: []
        }
    }

    componentDidMount() {
        let buttons: ButtonInfo[][] = []
        let btnGroup: ButtonInfo[] = []
        let stateMap = this.state.states
        for (let button of this.props.buttons) {
            stateMap.set(button.id, false)
            btnGroup.push(button)
            if (this.props.buttonsPerLine &&
                btnGroup.length === this.props.buttonsPerLine) {
                buttons.push(btnGroup)
                btnGroup = []
            }
        }
        if (btnGroup.length > 0) {
            buttons.push(btnGroup)
        }
        this.setState({ states: stateMap, buttons: buttons })
    }

    render() {
        return (
            <div className="btnGroup">
                {this.state.buttons.map((buttons: ButtonInfo[], i: number) => {
                    return (
                        <div className="innerBtnGroup" key={i}>
                            {buttons.map((button: ButtonInfo) => {
                                const clickFn = () => {
                                    let states = this.state.states
                                    states.set(button.id, !states.get(button.id))

                                    this.setState({ states: states })
                                    if (this.props.onChanged) {
                                        let active: string[] = []
                                        states.forEach((value: boolean, key: string) => {
                                            if (value) {
                                                active.push(key)
                                            }
                                        })

                                        this.props.onChanged(active)
                                    }
                                }
                                return (
                                    <div
                                        className={'btnGroupItem' + (this.state.states.get(button.id) ? ' active' : '')}
                                        key={button.id}
                                        onClick={clickFn}
                                    >
                                        {button.title}
                                    </div>
                                )
                            })}
                        </div>)
                })}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ButtonGroup.tsx